export default __webpack_public_path__ + "static/media/history_1990_02.4c429a1c.png";